import { jsx as a, jsxs as t } from "react/jsx-runtime";
import l from "react";
import { c as o } from "../clsx-OuTLNxxd.js";
import { R as c } from "../ResponsiveSanityImage-BfPbiFwC.js";
import { SectionContainer as i } from "../SectionContainer/SectionContainer.js";
const m = "HeroBanner-module_hero-banner__g6EFX",
  g = "HeroBanner-module_overlay-left__-zAb1",
  s = "HeroBanner-module_overlay-right__j5LxO",
  d = "HeroBanner-module_hero-image__l-2UW",
  _ = "HeroBanner-module_size-compact__w5-eG",
  h = "HeroBanner-module_background-image-container__zkIlw",
  u = "HeroBanner-module_overlay__p8f-I",
  B = "HeroBanner-module_left-panel__fzX0w",
  f = "HeroBanner-module_right-panel__EcE-1",
  H = "HeroBanner-module_center-panel__G1ckI",
  v = "HeroBanner-module_large-left-panel__SCt8u",
  P = "HeroBanner-module_large-right-panel__0dXzL",
  C = "HeroBanner-module_large-center-panel__uL2Kj",
  y = "HeroBanner-module_title__YFKsj",
  k = "HeroBanner-module_content__sQU-f",
  I = "HeroBanner-module_action-container__Rhkic",
  n = {
    heroBanner: m,
    overlayLeft: g,
    overlayRight: s,
    heroImage: d,
    sizeCompact: _,
    backgroundImageContainer: h,
    overlay: u,
    leftPanel: B,
    rightPanel: f,
    centerPanel: H,
    largeLeftPanel: v,
    largeRightPanel: P,
    largeCenterPanel: C,
    title: y,
    content: k,
    actionContainer: I
  },
  j = _ref => {
    let {
      children: e,
      size: r = "normal"
    } = _ref;
    return /* @__PURE__ */a("div", {
      className: o(n.leftPanel, {
        [n.largeLeftPanel]: r == "large"
      }),
      children: e
    });
  },
  x = _ref2 => {
    let {
      children: e,
      size: r = "normal"
    } = _ref2;
    return /* @__PURE__ */a("div", {
      className: o(n.rightPanel, {
        [n.largeRightPanel]: r == "large"
      }),
      children: e
    });
  },
  w = _ref3 => {
    let {
      children: e,
      size: r = "normal"
    } = _ref3;
    return /* @__PURE__ */a("div", {
      className: o(n.centerPanel, {
        [n.largeCenterPanel]: r == "large"
      }),
      children: e
    });
  },
  A = e => /* @__PURE__ */a("h1", {
    className: n.title,
    children: e.children
  }),
  E = e => /* @__PURE__ */a("h2", {
    className: n.content,
    children: e.children
  }),
  F = e => /* @__PURE__ */a("div", {
    className: n.actionContainer,
    children: e.children
  }),
  S = e => /* @__PURE__ */t("div", {
    className: o(n.heroBanner, e.className, {
      [n.overlayLeft]: e.overlay == "left",
      [n.overlayRight]: e.overlay == "right",
      [n.sizeCompact]: e.size == "compact"
    }),
    "data-content-name": "hero",
    children: [/* @__PURE__ */a("div", {
      className: n.backgroundImageContainer,
      children: e.backgroundImageComponent ? /* @__PURE__ */a(l.Fragment, {
        children: e.backgroundImageComponent
      }) : e.background ? /* @__PURE__ */a(c, {
        image: e.background,
        className: n.heroImage,
        defaultWidth: 1024,
        defaultHeight: 400,
        alt: e.backgroundAlt,
        loading: e.loading || void 0
      }) : null
    }), /* @__PURE__ */a(i, {
      className: o(n.overlay, e.overlayClassName),
      children: e.children
    })]
  });
export { S as HeroBanner, F as HeroBannerAction, w as HeroBannerCenterPanel, E as HeroBannerContent, j as HeroBannerLeftPanel, x as HeroBannerRightPanel, A as HeroBannerTitle };